import React, { useEffect, useState } from 'react';
import CustomNavLink from './CustomNavLink';
import img from './hamburger.svg';

export default function Header() {
  const windowWidth = window.innerWidth;
  const [navClass, setNavClass] = useState('collapsible-nav');
  const [navOpen, setNavOpen] = useState(false);
  useEffect(() => {
    if (windowWidth >= 992) {
      setNavClass('collapsible-nav show');
      setNavOpen(true);
    } else {
      setNavClass('collapsible-nav');
      setNavOpen(false);
    }
  }, [windowWidth]);

  const closeNavBar = () => {
    setNavClass('collapsible-nav');
    setNavOpen(false);
  };

  return (
    <header className='justify-content-between'>
      {/* <button class='btn btn-white btn-share ml-auto mr-3 ml-md-0 mr-md-auto'>
        <img src='assets/images/share.svg' alt='share' class='btn-img' />
        SHARE
      </button> */}
      {!(windowWidth >= 992) && (
        <div>
          <h4>Dr. Nithin M</h4>
        </div>
      )}

      <div class='ml-auto mr-3 ml-md-0 mr-md-auto '></div>
      <nav class={navClass} id='collapsible-nav'>
        <CustomNavLink to='/' closeNavBar={closeNavBar}>
          Home
        </CustomNavLink>
        <CustomNavLink to='/courses' closeNavBar={closeNavBar}>
          Courses
        </CustomNavLink>
        <CustomNavLink to='/publications' closeNavBar={closeNavBar}>
          Publications
        </CustomNavLink>
        <CustomNavLink to='/talks' closeNavBar={closeNavBar}>
          Talks
        </CustomNavLink>
        {/* <CustomNavLink to="/contact">CONTACT</CustomNavLink> */}
      </nav>
      <button
        class='btn btn-menu-toggle btn-white rounded-circle'
        data-toggle='collapsible-nav'
        data-target='collapsible-nav'
        onClick={() => {
          if (navOpen) {
            setNavClass('collapsible-nav');
            setNavOpen(false);
          } else {
            setNavClass('collapsible-nav show');
            setNavOpen(true);
          }
        }}
      >
        <img src={img} alt='hamburger' />
      </button>
    </header>
  );
}
